export const PATIENT_SURVEYS_FETCH_SURVEYS_REQUEST = 'PATIENT_SURVEYS_FETCH_SURVEYS_REQUEST';
export const PATIENT_SURVEYS_FETCH_SURVEYS_SUCCESS = 'PATIENT_SURVEYS_FETCH_SURVEYS_SUCCESS';
export const PATIENT_SURVEYS_FETCH_SURVEYS_FAILURE = 'PATIENT_SURVEYS_FETCH_SURVEYS_FAILURE';

export const PATIENT_SURVEYS_SELECT_SURVEY = 'PATIENT_SURVEYS_SELECT_SURVEY';